import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BsDropdownModule, CollapseModule, ModalModule} from 'ngx-bootstrap';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {NgxQRCodeModule} from '@techiediaries/ngx-qrcode';
import {ComponentsModule} from './components/components.module';


// FINGER
import {TitleBarComponent as fingerBar} from './components/finger/title-bar/title-bar.component';
import {TitleContextMenuComponent as titleFinger} from './components/finger/title-bar/title-context-menu/title-context-menu.component';
import {SplashComponent as fingerSplash} from './components/finger/title-bar/splash/splash.component';
import {FingerSelectionComponent} from './components/finger/finger-selection/finger-selection.component';
import {MissingFingersComponent} from './components/finger/finger-selection/missing-fingers/missing-fingers.component';
import {SdkRunComponent as sdk2} from './components/finger/sdk-run/sdk-run.component';
import {IndexComponent as indexFinger} from './components/finger/index/index.component';
import {FrameViewerComponent} from './components/finger/frame-viewer/frame-viewer.component';
import {UserSelectionComponent} from './components/finger/user-selection/user-selection.component';
import {TransactionDialogComponent as tdFinger} from './components/finger/sdk-run/dialogs/transaction-dialog/transaction-dialog.component';
import {ProgressDialogComponent as pdFinger} from './components/finger/sdk-run/dialogs/progress-dialog/progress-dialog.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// FACE
import {TitleBarComponent as faceBar} from './components/face/title-bar/title-bar.component';
import {TitleContextMenuComponent as titleFace} from './components/face/title-bar/title-context-menu/title-context-menu.component';
import {SplashComponent as faceSplash} from './components/face/title-bar/splash/splash.component';
import {SdkRunComponent as sdk1} from './components/face/sdk-run/sdk-run.component';
import {IndexComponent as indexFace} from './components/face/index/index.component';
import {TransactionDialogComponent as tdFace} from './components/face/dialogs/transaction-dialog/transaction-dialog.component';
import {ProgressDialogComponent as pdFace} from './components/face/dialogs/progress-dialog/progress-dialog.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {HttpRequestInterceptor} from './interceptors/http-token.interceptor';

import {IcarVisionService} from './services/mitek/icar.service';
import {DataService} from './services/mitek/dataIcar.service';
import {MitekService} from './services/mitek/mitek.service';
import {CallService} from './services/mitek/call.service';
import {ScriptService} from './services/mitek/ScriptService';
import { BackButtonDisableModule } from './modules/helpers/back-button-disable-module/back-button-disable-module';

import { SearchEnrollmentComponent } from './pages/searching-enroll/search-enrollment/search-enrollment.component';
import { DataModule } from './data/data-module';
import { ResultSearchEnrollmentComponent } from './pages/searching-enroll/result-search-enrollment/result-search-enrollment.component';
import { AuthGuard } from './guards/auth-guard-service ';


@NgModule({
  declarations: [AppComponent
    , fingerBar,
    titleFinger,
    fingerSplash,
    FingerSelectionComponent,
    MissingFingersComponent,
    sdk2,
    indexFinger,
    FrameViewerComponent,
    UserSelectionComponent,
    tdFinger,
    pdFinger,
    faceBar,
    titleFace,
    faceSplash,
    sdk1,
    indexFace,
    SearchEnrollmentComponent,
    ResultSearchEnrollmentComponent
  ],
  entryComponents: [MissingFingersComponent, FrameViewerComponent, tdFinger, pdFinger],
  imports: [BrowserModule,
    BackButtonDisableModule.forRoot(),
    ComponentsModule,
    BrowserAnimationsModule,
    NgxQRCodeModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    DataModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(), IonicModule.forRoot(), AppRoutingModule, ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})],
  providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}, FingerSelectionComponent,
    IcarVisionService,
    DataService,
    MitekService,
    CallService,
    ScriptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    AuthGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
